import React, { useState } from 'react';
import { supabase } from '../Servicios/supabaseClient';

export default function AfipModal({ userId, onClose, onSuccess }) {
    const [formData, setFormData] = useState({
        cuit: '',
        password: '',
        cuit_empresa: ''
    });
    const [entityType, setEntityType] = useState('person'); // 'person' | 'company'
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Guardamos CUIT y Password. Estado -> 'pendiente_validacion'
            const { error } = await supabase
                .from('afip_credentials')
                .upsert({
                    user_id: userId,
                    cuit: formData.cuit,
                    cuit_empresa: entityType === 'company' ? formData.cuit_empresa : null,
                    afip_password: formData.password,
                    status: 'pendiente_validacion',
                    updated_at: new Date()
                });

            if (error) throw error;

            // Éxito: Cerramos modal y actualizamos estado padre
            onSuccess();
            onClose();

        } catch (error) {
            alert('Error: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modalOverlay">
            <div className="modalContent">
                <h3 style={{ marginBottom: '1rem', color: 'white' }}>Configurar AFIP</h3>
                <p style={{ fontSize: '0.9rem', color: '#aaa', marginBottom: '1rem' }}>
                    Ingresa tus credenciales para generar los certificados automáticamente.
                </p>

                {/* Toggle Switch */}
                <div className="entityToggle">
                    <div
                        className={`toggleOption ${entityType === 'person' ? 'active' : ''}`}
                        onClick={() => setEntityType('person')}
                    >
                        Persona Física
                    </div>
                    <div
                        className={`toggleOption ${entityType === 'company' ? 'active' : ''}`}
                        onClick={() => setEntityType('company')}
                    >
                        Sociedad SRL/SA
                    </div>
                </div>

                <form onSubmit={handleSubmit}>

                    {/* CUIT Empresa Input - Solo visible si es Sociedad */}
                    {entityType === 'company' && (
                        <div style={{ marginBottom: '1rem', animation: 'fadeIn 0.3s' }}>
                            <label className="inputLabel">CUIT de la Empresa</label>
                            <input
                                type="number"
                                className="inputField"
                                placeholder="30123456789"
                                value={formData.cuit_empresa}
                                onChange={(e) => setFormData({ ...formData, cuit_empresa: e.target.value })}
                                required={entityType === 'company'}
                            />
                            <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
                                Ingresa el CUIT de la sociedad que deseas administrar.
                            </small>
                        </div>
                    )}

                    <div style={{ marginBottom: '1rem' }}>
                        <label className="inputLabel">
                            {entityType === 'company' ? 'CUIT del Administrador/Representante' : 'CUIT'}
                        </label>
                        <input
                            type="number"
                            className="inputField"
                            placeholder="20123456789"
                            value={formData.cuit}
                            onChange={(e) => setFormData({ ...formData, cuit: e.target.value })}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                        <label className="inputLabel">Contraseña AFIP</label>
                        <input
                            type="password"
                            className="inputField"
                            placeholder="********"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            required
                        />
                    </div>

                    <div className="modalActions">
                        <button type="button" onClick={onClose} className="btnSecondary">Cancelar</button>
                        <button type="submit" className="btnPrimary" disabled={loading}>
                            {loading ? 'Guardando...' : 'Conectar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}